export default {
  en: {
    'components.credentials-form.label': 'Marketplace',
    'components.credentials-form.submit': 'Authorize with Amazon',
    'components.credentials-form.cancel': 'Cancel',
    'components.credentials-form.placeholder': 'Select Marketplace',
    'components.credentials-form.hint':
      'You will be redirected to Amazon to complete authentication.',

    'components.credentials-form.marketplace.required': 'Please select a marketplace',

    'components.credentials-form.marketplaces.fallback-error':
      'Error loading marketplaces. Please try again.',
  },
};
